import {types} from './types';

const initialState = {
    list: [],
    search: {
        data: [],
        countPage: 1
    },
}

export function providerMobileReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_PROVIDER_LIST:
            return { ...state, list: action.payload};
        case types.SET_SEARCH_LIST:
            return { ...state, search: action.payload};
        default:
            return state
    }
}